import * as z from "zod"

export const WorkspaceAccessDbModel = z.object({
  workspaceId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  userId: z.string(),
})
